import React, { useState, useEffect, useCallback } from "react";
import {
  Avatar,
  Form,
  Input,
  Select,
  Button,
  Row,InputNumber,
  Col,
  notification,
  message
} from "antd";
import { useDropzone } from "react-dropzone";

import NoAvatar from "../../../../assets/img/png/no-avatar.png";
import {
  uploadAvatarApi,
  getAvatarApi,
} from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { put } from "../../../../api/put";
import "./EditVehiclesForm.scss";

export default function EditVehiclesForm(props) {
  const { vehicle, setIsVisibleModal, setReloadVehicles } = props;
  const [avatar, setAvatar] = useState(null);
  const [vehicleData, setVehicleData] = useState({});

  useEffect(() => {
    vehicle.capacityitems= parseInt(vehicle.capacityitems)
    vehicle.capacityweigh= parseFloat(vehicle.capacityweigh)
    vehicle.speed= parseFloat(vehicle.speed)
    vehicle.fixcost= parseFloat(vehicle.fixcost)
    vehicle.kmcost= parseFloat(vehicle.kmcost)
    vehicle.hourcost= parseFloat(vehicle.hourcost)
    vehicle.co2emissions= parseFloat(vehicle.co2emissions)
    setVehicleData({
      name: vehicle.name,
      types: vehicle.types,
      capacityitems: vehicle.capacityitems,
      capacityweigh: vehicle.capacityweigh,
      speed: vehicle.speed,
      fixcost: vehicle.fixcost,
      kmcost: vehicle.kmcost,
      hourcost: vehicle.hourcost,
      co2emissions: vehicle.co2emissions,
    });
  }, [vehicle]);

  useEffect(() => {
    if (vehicle.avatar) {
      // getAvatarApi(worker.avatar).then((response) => {
      //   setAvatar(response);
      // });
      setAvatar(vehicle.avatar)
    } else {
      setAvatar(null);
    }
  }, [vehicle]);

  useEffect(() => {
    if (avatar) {
      setVehicleData({ ...vehicleData, avatar: avatar.file });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatar]);

  const updateVehicle = (e) => {
   //console.log('he entrado al updateuser')
    e.preventDefault();
    const token = getAccessTokenApi();
    let vehicleUpdate = vehicleData;

    if (!vehicleUpdate.name ||
       !vehicleUpdate.types ||
       !vehicleUpdate.speed ||
       !vehicleUpdate.capacityweigh ||
       !vehicleUpdate.fixcost ||
       !vehicleUpdate.kmcost ||
       !vehicleUpdate.co2emissions ||
       !vehicleUpdate.hourcost ||
        !vehicleUpdate.capacityitems) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios",
      // });
      message.error("Todos los campos son obligatorios")
      return;
    }
    
    if (typeof vehicleUpdate.avatar === "object") {
      uploadAvatarApi(token, vehicleUpdate.avatar, vehicle.name,'upload-avatar-vehicle').then((response) => {
        vehicleUpdate.avatar = response.avatarName;
        put(vehicleUpdate,'update-vehicle','update-vehicle',`/${vehicle.name}` ).then((result) => {
        // updateVehicleApi(token, vehicleUpdate, vehicle.name).then((result) => {
          // notification["success"]({
          //   message:'Changes saved!',
          // });
          message.success('Changes saved!')
          setIsVisibleModal(false);
          setReloadVehicles(true);
        });
      });
    } else {
      put(vehicleUpdate,'update-vehicle','update-vehicle',`/${vehicle.name}` ).then((result) => {
      // updateVehicleApi(token, vehicleUpdate, vehicle.name).then((result) => {
        // notification["success"]({
        //   message: 'Changes saved!',
        // });
        message.success('Changes saved!')
        setIsVisibleModal(false);
        setReloadVehicles(true);
      });
    }
  };

  return (
    <div className="edit-user-form">
      <UploadAvatar avatar={avatar} setAvatar={setAvatar} />
      <EditForm
        vehicleData={vehicleData}
        vehicle={vehicle}
        setVehicleData={setVehicleData}
        updateVehicle={updateVehicle}
      />
    </div>
  );
}

function UploadAvatar(props) {
  const { avatar, setAvatar } = props;
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (avatar) {
      if (avatar.preview) {
        setAvatarUrl(avatar.preview);
      } else {
        setAvatarUrl(avatar);
      }
    } else {
      setAvatarUrl(null);
    }
  }, [avatar]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      setAvatar({ file, preview: URL.createObjectURL(file) });
    },
    [setAvatar]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "image/jpeg, image/png",
    noKeyboard: true,
    onDrop,
  });

  return (
    <div className="upload-avatar" {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <Avatar size={150} src={NoAvatar} />
      ) : (
        <Avatar size={150} src={avatarUrl ? avatarUrl : NoAvatar} />
      )}
    </div>
  );
}

function EditForm(props) {
  const { vehicleData, setVehicleData, updateVehicle,vehicle } = props;
  const { Option } = Select;

  return (
    <Form className="form-edit" onSubmit={updateVehicle}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={vehicleData.name}
              onChange={(e) =>
                setVehicleData({ ...vehicleData, name: e.target.value })
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Vehicle type"
              onChange={(e) => setVehicleData({ ...vehicleData, types: e })}
              value={vehicleData.types}
            >
              <Option value="bike">Bike</Option>
              <Option value="van">Van</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Capacity Items'
              name='capacityitems'
              min={0}
              max={9999999}
              step={1}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.capacityitems} 
              value={vehicleData.capacityitems}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, capacityitems: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Capacity weight'
              name='capacityweight'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.capacityweigh} 
              value={vehicleData.capacityweigh}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, capacityweigh: e })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Speed'
              name='speed'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.speed} 
              value={vehicleData.speed}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, speed: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Fix cost'
              name='fixcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.fixcost} 
              value={vehicleData.fixcost}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, fixcost: e })}}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Km cost'
              name='kmcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.kmcost} 
              value={vehicleData.kmcost}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, kmcost: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Hour cost'
              name='hourcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.hourcost} 
              value={vehicleData.hourcost}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, hourcost: e })}}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='CO2 emissions'
              name='co2emissions'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={vehicle.co2emissions} 
              value={vehicleData.co2emissions}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, co2emissions: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn-submit" onClick={updateVehicle}>
              Update vehicles
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
